<template>
  <div class="fade">
    <div class="s-home">
      <div class="illustration--container">
        <div class="bg-stars">
          <div class="astronaut--container vibrate-2">
            <img src="@/assets/astronaut.svg" alt class="astrounaut" />
          </div>
        </div>
      </div>
      <div class="container h-100">
        <div class="positon-relative">
          <div class="row">
          <div class="jumbotron--container">
            <h1 class="jumbotron--header display-4">Orbit</h1>
            <h1 class="jumbotron--header display-4">Pathfinder</h1>
            <h3 class="jumbotron--subheader text-muted"
            >Your journey of self development starts here.</h3>
            <p class="mb-5 font-light jumbotron--desc"
            >A community for final year students and fresh graduates who focuses on career and self-development.</p>
            <router-link :to="{name: 'SignUp'}">
              <button class="btn btn-primary">Sign Up</button>
            </router-link>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TimelineMax, Linear, Expo } from "gsap";
const timeline = new TimelineMax();

export default {
  mounted() {
    timeline.to(".fade", 0.2, {
      opacity: 1,
      ease: Linear.easeNone
    });
  },
  beforeRouteLeave(to, from, next) {
    timeline.to('.jumbotron--container', 0.4, {
        opacity: 0,
        ease: Linear.easeNone,
      })
      .to('.illustration--container', 1, {
        width: '100%',
        transformOrigin: '50%',
        ease: Expo.easeInOut,
        onComplete: () => {
          next();
        }
      })
      .to('.bg-stars', 0.4, {
        opacity: 0,
      }, '-=1.6');
  }
};
</script>

<style>
</style>